module.exports = __webpack_public_path__ + "img/logo.98f5fc46.svg";